import axios from 'axios';
// config
import { WS_ESHOP_DOMAIN } from '../config-global';

// ---------------------------------------------------------------------- add Access Token

const axiosWithAtInstance = axios.create({ baseURL: WS_ESHOP_DOMAIN });

export default axiosWithAtInstance;
